const steps = [
    { n: "01", t: "Cerere", d: "Completezi formularul în 60 de secunde sau ne suni direct." },
    { n: "02", t: "Analiză", d: "Studiem nevoile tale și consultăm ofertele a 20+ companii partenere." },
    { n: "03", t: "Oferte", d: "Primești 5+ oferte comparate, cu plusuri și minusuri clare." },
    { n: "04", t: "Decizie", d: "Alegi în liniște. Noi ne ocupăm de toată documentația." },
];

export default function HowItWorks() {
    return (
        <section id="proces" data-testid="process-section" className="bg-[#0d3d2e] text-[#fcfbf8] py-24 lg:py-32 relative grain-overlay">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-16">
                    <div className="lg:col-span-5">
                        <div className="text-xs uppercase tracking-[0.2em] text-[#d4af37] mb-4">
                            02 — Proces
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
                            Patru pași simpli.<br />
                            <em className="not-italic text-[#fcfbf8]/60">Zero presiune.</em>
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="text-base lg:text-lg text-[#fcfbf8]/75">
                            Consultanța noastră este 100% gratuită. La încheierea poliței plătești
                            tariful standard al asigurătorului, fără cost suplimentar pentru serviciile noastre.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
                    {steps.map((s, i) => (
                        <div key={s.n} className="relative" data-testid={`step-${s.n}`}>
                            <div className="font-display text-7xl lg:text-8xl text-[#d4af37]/30 leading-none mb-3">
                                {s.n}
                            </div>
                            <h3 className="font-display text-2xl mb-2">{s.t}</h3>
                            <p className="text-sm text-[#fcfbf8]/70 max-w-[24ch]">{s.d}</p>
                            {i < steps.length - 1 && (
                                <div className="hidden lg:block absolute top-10 right-[-1.5rem] h-px w-12 bg-[#fcfbf8]/20" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
